import React from 'react';
import PropTypes from 'prop-types';
import * as UTILS_THEMES from './../utils/utilsThemes.js';

import emblueFull from '../assets/images/logos/emblue/full.svg';
import emblueSmall from '../assets/images/logos/emblue/small.svg';

const Logo = ({ theme, isEmBlue }) => {
  const getFullLogoURL = theme =>
    UTILS_THEMES.getCurrentThemeURL(theme) +
    'globals/src/images/logos/logo_MDirector_header_trans.png';

  const getMiniLogoURL = theme =>
    UTILS_THEMES.getCurrentThemeURL(theme) +
    'globals/src/images/logos/logo_MDirector_mini_trans.png';

  if (isEmBlue) {
    return (
      <div className="logo__container logo__container--emblue">
        <img alt="emBlue" src={emblueFull} className="logo__image logo--full" />
        <img alt="emBlue" src={emblueSmall} className="logo__image logo--mini" />
      </div>
    );
  }

  return (
    <div className="logo__container">
      <img
        alt="MDirector"
        src={getFullLogoURL(theme)}
        className="logo__image logo--full"
        width="150"
      />
      <img
        alt="MDirector"
        src={getMiniLogoURL(theme)}
        className="logo__image logo--mini"
        width="30"
      />
    </div>
  );
};

Logo.propTypes = {
  theme: PropTypes.string.isRequired,
  isEmBlue: PropTypes.bool,
};

export default Logo;
